import React from 'react';
import HandledAbandonedChart from '../CallCharts/HandledAbandonedChart';
import RejectedMissedChart from '../CallCharts/RejectedMissedChart';
import CallVolumePerHour from '../CallCharts/CallVolumePerHour';

export default function CallChartsSection({ data, filters }) {
  if (!data.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '100%' }}>
      <CallVolumePerHour data={data} filters={filters} />
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
        <HandledAbandonedChart data={data} filters={filters} />
        <RejectedMissedChart data={data} filters={filters} />
      </div>
    </div>
  );
}
